import { defineAsyncComponent } from 'vue';

export * from './components';

export const integrationsSettingsMicroFrontends = {
	IntegrationsSettingsCalendarUserList: defineAsyncComponent(
		() =>
			import('./components/IntegrationsSettingsCalendar/IntegrationsSettingsCalendarUserList.vue')
	),
	IntegrationsStripeSettings: defineAsyncComponent(
		() =>
			import('./components/IntegrationsStripeSettings/IntegrationsStripeSettings.vue')
	),
	IntegrationsDimensionBlock: defineAsyncComponent(
		() =>
			import('./components/IntegrationsDimension/IntegrationsDimensionBlock.vue')
	),
	IntegrationsCustomScripts: defineAsyncComponent(
		() =>
			import('./components/IntegrationsCustomScripts/IntegrationsCustomScripts.vue')
	),
	IntegrationsDatePicker: defineAsyncComponent(
		() => import('./components/IntegrationsDatePicker.vue')
	),
	IntegrationsModuleToggle: defineAsyncComponent(
		() => import('./components/IntegrationsModuleToggle.vue')
	),
	AvalaraMappingModal: defineAsyncComponent(
		() =>
			import('./components/Avalara/AvalaraMappingModal/AvalaraMappingModal.vue')
	),
	AvalaraMappingsList: defineAsyncComponent(
		() =>
			import('./components/Avalara/AvalaraMappingsList/AvalaraMappingsList.vue')
	),
	AvalaraFieldMappingSection: defineAsyncComponent(
		() =>
			import('./components/Avalara/AvalaraFieldMappingSection/AvalaraFieldMappingSection.vue')
	),
	AvalaraFieldMappingModal: defineAsyncComponent(
		() =>
			import('./components/Avalara/AvalaraFieldMappingModal/AvalaraFieldMappingModal.vue')
	),
};
